import { MantineProvider, createTheme, ColorSchemeScript } from '@mantine/core'
import { Notifications } from '@mantine/notifications'
import React from 'react'

type Props = { children: React.ReactNode }

export function AppThemeProvider({ children }: Props) {
  const [scheme, setScheme] = React.useState<'light' | 'dark'>(() => {
    try { return (localStorage.getItem('theme.scheme') as any) || 'light' } catch { return 'light' }
  })

  const theme = React.useMemo(() => createTheme({
    primaryColor: 'indigo',
    defaultRadius: 'md',
    colors: {
      indigo: ['#edf2ff','#dbe4ff','#bac8ff','#91a7ff','#748ffc','#5c7cfa','#4c6ef5','#4263eb','#3b5bdb','#364fc7']
    },
    fontFamily: 'Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif',
    fontSizes: {
      xs: 13,
      sm: 15,
      md: 17,
      lg: 19,
      xl: 22
    },
    headings: {
      fontWeight: '800',
      sizes: {
        h1: { fontSize: '2.4rem' },
        h2: { fontSize: '2rem' },
        h3: { fontSize: '1.6rem' },
        h4: { fontSize: '1.3rem' },
        h5: { fontSize: '1.1rem' },
        h6: { fontSize: '1rem' }
      }
    }
  }), [])

  React.useEffect(() => {
    try { localStorage.setItem('theme.scheme', scheme) } catch {}
    const cls = document.documentElement.classList
    if (scheme === 'dark') {
      cls.add('dark')
    } else {
      cls.remove('dark')
    }
  }, [scheme])

  return (
    <>
      <ColorSchemeScript defaultColorScheme={scheme} />
      <MantineProvider theme={theme} defaultColorScheme={scheme}>
        <Notifications position="top-center" />
        {children}
      </MantineProvider>
    </>
  )
}

export function useThemeScheme() {
  const [scheme, setScheme] = React.useState<'light' | 'dark'>(() => {
    try { return (localStorage.getItem('theme.scheme') as any) || 'light' } catch { return 'light' }
  })
  React.useEffect(() => {
    try { localStorage.setItem('theme.scheme', scheme) } catch {}
    const cls = document.documentElement.classList
    if (scheme === 'dark') {
      cls.add('dark')
    } else {
      cls.remove('dark')
    }
  }, [scheme])
  return { scheme, setScheme }
}
